import { useTranslation } from 'react-i18next'
import PageHeading from 'components/atoms/PageHeading'
import PageBody from 'components/atoms/PageBody'
import SetupEntitySettingForm from 'components/organisms/forms/SetupEntitySettingForm'
import { 
  useGET_accommodationCategoriesQuery, 
  usePOST_accommodationCategoryDisableMutation, 
  usePOST_accommodationCategoryEnableMutation, 

  useGET_modificationCategoriesQuery, 
  usePOST_modificationCategoryDisableMutation, 
  usePOST_modificationCategoryEnableMutation, 

  useGET_assessmentCategoriesQuery, 
  usePOST_assessmentCategoryDisableMutation, 
  usePOST_assessmentCategoryEnableMutation, 

  useGET_instructionalStrategyCategoriesQuery, 
  usePOST_instructionalStrategyCategoryDisableMutation, 
  usePOST_instructionalStrategyCategoryEnableMutation,

  useGET_interventionStrategyCategoriesQuery, 
  usePOST_interventionStrategyCategoryDisableMutation, 
  usePOST_interventionStrategyCategoryEnableMutation,

  useGET_schoolSetupInterventionTypesQuery, 
  usePOST_interventionTypeDisableMutation, 
  usePOST_interventionTypeEnableMutation,

  useGET_schoolSetupConcernReasonsQuery, 
  usePOST_concernReasonDisableMutation, 
  usePOST_concernReasonEnableMutation,

  useGET_schoolSetupProblemAreasQuery, 
  usePOST_problemAreaDisableMutation, 
  usePOST_problemAreaEnableMutation,

  useGET_schoolSetupProgressMonitoringToolsQuery, 
  usePOST_progressMonitoringToolDisableMutation, 
  usePOST_progressMonitoringToolEnableMutation,

  useGET_schoolSetupMonitoringMethodsQuery, 
  usePOST_monitoringMethodDisableMutation, 
  usePOST_monitoringMethodEnableMutation,
  usePOST_subjectEnableMutation,
  usePOST_subjectDisableMutation,
  useGET_schoolSetupSubjectsQuery,
  useGET_schoolSetupTopicsQuery,
  usePOST_topicEnableMutation,
  usePOST_topicDisableMutation,
  usePOST_fluencyEnableMutation,
  usePOST_fluencyDisableMutation,
  useGET_schoolSetupHighlightsQuery,
  usePOST_highlightEnableMutation,
  usePOST_highlightDisableMutation,
  useGET_schoolSetupMeasuresQuery,
  usePOST_measureEnableMutation,
  usePOST_measureDisableMutation,
  useGET_schoolSetupSkillsQuery,
  usePOST_skillEnableMutation,
  usePOST_skillDisableMutation,
  useGET_schoolSetupFluenciesQuery,

} from 'redux/api/setupApi'
import { useParams } from 'react-router-dom'

const SetupEntitySettingCrudPage = () => {
  const { t } = useTranslation()
  
  const params = useParams()
  const type = params?.type
  

  const map = {
    'subjects': {
      component: null,
      listQuery: useGET_schoolSetupSubjectsQuery,
      enableMutation: usePOST_subjectEnableMutation,
      disableMutation: usePOST_subjectDisableMutation,
    },
    'topics': {
      component: null,
      listQuery: useGET_schoolSetupTopicsQuery,
      enableMutation: usePOST_topicEnableMutation,
      disableMutation: usePOST_topicDisableMutation,
    },
    'fluencies': {
      component: null,
      listQuery: useGET_schoolSetupFluenciesQuery,
      enableMutation: usePOST_fluencyEnableMutation,
      disableMutation: usePOST_fluencyDisableMutation,
    },
    'highlights': {
      component: null,
      listQuery: useGET_schoolSetupHighlightsQuery,
      enableMutation: usePOST_highlightEnableMutation,
      disableMutation: usePOST_highlightDisableMutation,
    },
    'measures': {
      component: null,
      listQuery: useGET_schoolSetupMeasuresQuery,
      enableMutation: usePOST_measureEnableMutation,
      disableMutation: usePOST_measureDisableMutation,
    },
    'skills': {
      component: null,
      listQuery: useGET_schoolSetupSkillsQuery,
      enableMutation: usePOST_skillEnableMutation,
      disableMutation: usePOST_skillDisableMutation,
    },
    'accommodations': {
      component: null,
      listQuery: useGET_accommodationCategoriesQuery,
      enableMutation: usePOST_accommodationCategoryEnableMutation,
      disableMutation: usePOST_accommodationCategoryDisableMutation,
    },
    'modifications': {
      component: null,
      listQuery: useGET_modificationCategoriesQuery,
      enableMutation: usePOST_modificationCategoryEnableMutation,
      disableMutation: usePOST_modificationCategoryDisableMutation,
    },
    'assessment-strategies': {
      component: null,
      listQuery: useGET_assessmentCategoriesQuery,
      enableMutation: usePOST_assessmentCategoryEnableMutation,
      disableMutation: usePOST_assessmentCategoryDisableMutation,
    },
    'intervention-strategies': {
      component: null,
      listQuery: useGET_interventionStrategyCategoriesQuery,
      enableMutation: usePOST_interventionStrategyCategoryEnableMutation,
      disableMutation: usePOST_interventionStrategyCategoryDisableMutation,
    },
    'instructional-strategies': {
      component: null,
      listQuery: useGET_instructionalStrategyCategoriesQuery,
      enableMutation: usePOST_instructionalStrategyCategoryEnableMutation,
      disableMutation: usePOST_instructionalStrategyCategoryDisableMutation,
    },
    'intervention-types': {
      component: null,
      listQuery: useGET_schoolSetupInterventionTypesQuery,
      enableMutation: usePOST_interventionTypeEnableMutation,
      disableMutation: usePOST_interventionTypeDisableMutation,
    },
    'concern-reasons': {
      component: null,
      listQuery: useGET_schoolSetupConcernReasonsQuery,
      enableMutation: usePOST_concernReasonEnableMutation,
      disableMutation: usePOST_concernReasonDisableMutation,
    },
    'problem-areas': {
      component: null,
      listQuery: useGET_schoolSetupProblemAreasQuery,
      enableMutation: usePOST_problemAreaEnableMutation,
      disableMutation: usePOST_problemAreaDisableMutation,
    },
    'progress-monitoring-tools': {
      component: null,
      listQuery: useGET_schoolSetupProgressMonitoringToolsQuery,
      enableMutation: usePOST_progressMonitoringToolEnableMutation,
      disableMutation: usePOST_progressMonitoringToolDisableMutation,
    },
    'monitoring-methods': {
      component: null,
      listQuery: useGET_schoolSetupMonitoringMethodsQuery,
      enableMutation: usePOST_monitoringMethodEnableMutation,
      disableMutation: usePOST_monitoringMethodDisableMutation,
    },
  }

  const {data: data} = map[type].listQuery({show_disabled: true})

  
  return (
    map[type] && data &&  <>
          <PageBody>
              {data.results.map(entity => <SetupEntitySettingForm 
                key={entity.id}
                type={type} 
                entity={entity}
                enableMutation={map[type].enableMutation}
                disableMutation={map[type].disableMutation}
                />)}
          </PageBody>  
        </>
   
  )
}
export default SetupEntitySettingCrudPage
